<template>
  <div class="senior">
    <el-tabs v-model="activeName"
             @tab-click="handleClick"
             class="tabs">
      <el-tab-pane label="全部货源"
                   name="0"></el-tab-pane>
      <el-tab-pane label="待匹配"
                   name="1"></el-tab-pane>
      <el-tab-pane label="匹配中"
                   name="2"></el-tab-pane>
      <el-tab-pane label="匹配完成"
                   name="3"></el-tab-pane>
      <el-tab-pane label="已失效"
                   name="4"></el-tab-pane>
    </el-tabs>
    <div class="senior-search">
      <el-form :inline="true"
               :model="formInline"
               class="search-form-inline "
               label-position="right">
        <span class="imp">出发地</span>
        <el-cascader size="small"
                     class="addressStyle"
                     @active-item-change="handleItemChange"
                     :options="options"
                     v-model="addressFrom"
                     @change="handleChangeFrom">
        </el-cascader>
        <span class="imp">目的地</span>
        <el-cascader size="small"
                     class="addressStyle"
                     :options="options"
                     v-model="addressTo"
                     @active-item-change="handleItemChange"
                     @change="handleChangeTo">
        </el-cascader>
        <el-form-item label="原料"
                      class="material"
                      size="small">
          <el-input v-model="formInline.material"
                    placeholder="请输入原料名称"
                    class="material-name"></el-input>
        </el-form-item>
        <el-form-item class="itembtn"
                      size="small">
          <el-button class="search-submit"
                     type="primary"
                     @click="onSubmit">查询</el-button>
        </el-form-item>
        <el-form-item label="开始时间"
                      size="small">
          <el-date-picker v-model="startDate"
                          type="date"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          placeholder="选择开始时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间"
                      size="small">
          <el-date-picker v-model="endDate"
                          type="date"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          placeholder="选择结束时间">
          </el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <div class="senior-container">
      <el-table :data="seniorGoodsInfo.result"
                style="width: 100%"
                height="100%"
                class="table_main">
        <el-table-column class-name="number"
                         label="序号"
                         align="center"
                         type="index"
                         min-width="40"
                         fixed>
        </el-table-column>
        <el-table-column class-name="sourceNumber"
                         prop="goodsNum"
                         label="货源编号">
        </el-table-column>
        <el-table-column label="货主信息">
          <template slot-scope="scope">
            <div><span>公司名称：</span>{{scope.row.userCompanyName}}</div>
            <div><span>联系人姓名：</span>{{scope.row.userCompanyLinkman}}</div>
            <div><span>联系电话：</span>{{scope.row.userCompanyIphone}}</div>
          </template>
        </el-table-column>
        <el-table-column label="位置信息">
          <template slot-scope="scope">
            <div><span>出发地：</span>{{scope.row.departLand}}{{scope.row.departLandDetails}}</div>
            <div><span>目的地：</span>{{scope.row.destina}}{{scope.row.destinaDetails}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="sourceInfo"
                         label="货源信息">
          <template slot-scope="scope">
            <div><span>期望运费：</span>{{scope.row.expectFreight}}元/吨</div>
            <div><span>炼厂名称：</span>{{scope.row.refineryName}}</div>
            <div><span>原料：</span>{{scope.row.material}}</div>
            <div><span>重量：</span>{{scope.row.totalWeight}}吨</div>
            <div v-if="scope.row.tankBody === '0'"><span>罐体：</span>铝罐</div>
            <div v-else-if="scope.row.tankBody === '1'"><span>罐体：</span>铁罐</div>
            <div v-else-if="scope.row.tankBody === '2'"><span>罐体：</span>钢罐</div>
            <div v-else-if="scope.row.tankBody === '3'"><span>罐体：</span>铝合金</div>
            <div v-else-if="scope.row.tankBody === '4'"><span>罐体：</span>不限</div>
            <div><span>货源有效期：</span>{{scope.row.startTimestr}} 至 {{scope.row.endTimestr}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="matchInfo"
                         label="匹配详情">
          <template slot-scope="scope">
            <div><span>已匹配重量：</span><span>{{scope.row.matchWeight}}</span>吨</div>
            <div><span>已匹配车辆：</span>{{scope.row.matchVehicle}}辆</div>
            <div><span>已谈成重量：</span>{{scope.row.talkWeight}}吨</div>
            <div><span>已谈成车辆：</span>{{scope.row.talkVehicle}}辆</div>
          </template>
        </el-table-column>
        <el-table-column label="状态"
                         header-align="center"
                         align="center"
                         width="67">
          <template slot-scope="scope">
            <!-- "goodsState": "0",                                          //货源状态 0待匹配 1.匹配中 2.匹配完成 3.已失效 -->
            <div v-if="scope.row.goodsState === '0'"
                 class="status-style wating">待匹配</div>
            <div v-else-if="scope.row.goodsState === '1'"
                 class="status-style progress">匹配中</div>
            <div v-else-if="scope.row.goodsState === '2'"
                 class="status-style complated">匹配完成</div>
            <div v-else-if="scope.row.goodsState === '3'"
                 class="status-style failure">已失效</div>
          </template>
        </el-table-column>
        <el-table-column header-align="center"
                         label="操作"
                         width="140"
                         align="center">
          <template slot-scope="scope">
            <el-button type="success"
                       class="btnb"
                       v-show="scope.row.goodsState === '0' | scope.row.goodsState === '1'"
                       @click="userPermissionClick(scope.row.seniorGoodsId)">
              权限用户
            </el-button>

            <el-button type="primary"
                       class="btna"
                       v-show="scope.row.goodsState === '0' | scope.row.goodsState === '1'"
                       @click="handleCarinfoClick(scope.row.seniorGoodsId)">匹配车辆</el-button>
            <el-button type="primary"
                       plain
                       class="btnc"
                       v-show="scope.row.goodsState === '1' | scope.row.goodsState === '2'"
                       @click="handleDetailClick(scope.row.seniorGoodsId)">
              <!-- <router-link to="matchingInfo">匹配详情</router-link> -->
              匹配详情
            </el-button>

          </template>
        </el-table-column>
      </el-table>
      <el-dialog title="权限用户"
                 :visible.sync="userPermissionTable"
                 class="userPermissionTable">
        <el-autocomplete class="inline-input permission_search"
                         size='small'
                         v-model="inputName"
                         :fetch-suggestions="querySearch"
                         placeholder="请输入公司名称"
                         :trigger-on-focus="false">
          <i class="el-icon-search el-input__icon"
             slot="suffix"
             @click="handleSearchClick">
          </i>
        </el-autocomplete>
        <el-table ref="multipleTable"
                  :data="userPermissionData"
                  tooltip-effect="dark"
                  style="width: 100%"
                  height="300"
                  @selection-change="handleSelectionChange">
          <el-table-column type="selection"
                           min-width="56">
          </el-table-column>
          <el-table-column prop="petname"
                           label="姓名"
                           align="center"
                           min-width="75">
          </el-table-column>
          <el-table-column prop="companyName"
                           label="公司名称"
                           align="center"
                           show-overflow-tooltip
                           min-width="240">
          </el-table-column>
          <el-table-column prop="praise"
                           label="好评率"
                           align="center"
                           min-width="80">
            <!-- <template slot-scope="scope">{{scope.row.praise}}%</template> -->
          </el-table-column>
          <el-table-column prop="totalMileage"
                           label="行驶里程(公里)"
                           align="center"
                           min-width="120">
          </el-table-column>
          <el-table-column class-name="operation"
                           label="操作"
                           align="center"
                           min-width="102">
            <template slot-scope="scope">
              <el-button type="primary"
                         v-if="scope.row.type==='0'"
                         @click="handleAddClick(scope.row.userId)">添加
              </el-button>
              <el-button type="primary"
                         v-else-if="scope.row.type==='1'"
                         @click="handleCancelClick(scope.row.userId)">取消
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 20px"
             class="operations"
             align="left">
          <el-button type="success"
                     plain
                     @click="toggleSelection(userPermissionData)">反选</el-button>
          <el-button type="primary"
                     @click="handleAddsClick">添加</el-button>
          <el-button type="primary"
                     plain
                     @click="handleCancelLot">取消</el-button>
        </div>
      </el-dialog>
      <el-dialog title="匹配详情"
                 :visible.sync="showDetails"
                 class="biddingTable"
                 trigger="click">
        <el-table ref="multipleTable"
                  :data="detailList"
                  tooltip-effect="dark"
                  style="width: 100%"
                  max-height="491">
          <el-table-column class-name="number"
                           label="序号"
                           align="center"
                           type="index"
                           min-width="40">
          </el-table-column>

          <el-table-column label="车辆编号"
                           align="left"
                           width="100">
            <template slot-scope="scope">{{scope.row.driverOrderNum}}</template>
          </el-table-column>
          <el-table-column label="物流公司"
                           align="left"
                           header-align="center"
                           min-width="155">
            <template slot-scope="scope">
              <div><span>公司名称：</span>{{scope.row.userCompanyName}}</div>
              <div><span>联系人姓名：</span>{{scope.row.userCompanyLinkman}}</div>
              <div><span>联系电话：</span>{{scope.row.userCompanyIphone}}</div>
            </template>
          </el-table-column>
          <el-table-column label="车辆信息"
                           align="left"
                           header-align="center"
                           min-width="120">
            <template slot-scope="scope">
              <div><span>车头号:</span>{{scope.row.headNumber}}</div>
              <div><span>车挂号：</span>{{scope.row.tailNumber}}</div>
              <div><span>核载量：</span>{{scope.row.nuclearLoadTonnage}}吨</div>
              <div><span>介质类别:</span>{{scope.row.mediumClass}}</div>
            </template>
          </el-table-column>
          <el-table-column label="司机信息"
                           align="left"
                           header-align="center"
                           min-width="135">
            <template slot-scope="scope">
              <div><span>姓名:</span>{{scope.row.dirverName}}</div>
              <div><span>手机号:</span>{{scope.row.dirverPhone}}</div>
              <div><span>身份证号:</span>
                <div>{{scope.row.dirverIdCardNo}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="车辆状态"
                           align="center"
                           header-align="center"
                           min-width="80">
            <template slot-scope="scope">
              <div v-if="scope.row.orderState === '0'"
                   class="stylus_car">待运输</div>
              <div v-else-if="scope.row.orderState === '1'"
                   class="stylus_car">运输中</div>
              <div v-else-if="scope.row.orderState === '2'"
                   class="stylus_car completed">运输完成</div>
              <div v-else-if="scope.row.orderState === '3'"
                   class="stylus_car canceled">已取消</div>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
      <!-- 分页 -->

    </div>
    <div class="pages">
      <span class="demonstartion"> 共{{seniorGoodsInfo.total}}条记录</span>
      <el-pagination @current-change="handleCurrentChange"
                     :page-size="seniorGoodsInfo.pageSize"
                     layout="prev, pager, next"
                     :total="seniorGoodsInfo.total"
                     background>
      </el-pagination>
    </div>
  </div>
</template>
<script>
import {
  userPermission,
  heightSource,
  heightSave,
  heightDelete,
  heightDriverOrder,
  allCompanyList,
  provinceList,
  cityList,
  areaList
} from 'apis/index'
export default {
  name: 'Container',
  data () {
    return {
      options: [],
      addressFrom: [],
      addressTo: [],
      from: '',
      to: '',
      address: '',
      seniorGoodsInfo: {},
      activeName: '0',
      userPermissionTable: false,
      showDetails: false,
      userPermissionData: [],
      inputName: '',
      multipleSelection: [],
      seniorGoodsId: '',
      detailList: [],
      companyList: [],
      formInline: {
        material: '',
        from: '',
        to: ''
      },
      startDate: '',
      endDate: ''

    }
  },

  methods: {
    async initData () { // 省市区三级联动
      let ret = await provinceList()
      if (ret.data.code === 0) {
        let newData = JSON.stringify(ret.data.data.result)
        newData = newData.replace(/provinceCode/g, 'value')
        newData = newData.replace(/provinceName/g, 'label')
        this.options = JSON.parse(newData)
        this.options.forEach((item, index) => {
          this.$set(this.options[index], 'children', [])
        })
        // console.log('11')
      }
    },
    async handleItemChange (val) {
      // console.log('active item:', val)
      // console.log(val)
      if (val.length === 1) { // 请求省，且只第一次才发请求
        let provinceCode = val[0]
        for (let j = 0; j < this.options.length; j++) {
          if (this.options[j].value === provinceCode && !this.options[j].children.length) {
            let ret = await cityList({ provinceCode })
            if (ret.data.code === 0) {
              let newData = JSON.stringify(ret.data.data.result)
              newData = newData.replace(/cityCode/g, 'value')
              newData = newData.replace(/cityName/g, 'label')
              let newCity = JSON.parse(newData)
              newCity.forEach(item => {
                item.children = []
              })
              this.$set(this.options[j], 'children', newCity)
              break
            }
          }
        }
      }
      if (val.length === 2) { // 请求市区，且只第一次才发请求
        let provinceCode = val[0]
        let cityCode = val[1]
        for (let j = 0; j < this.options.length; j++) {
          if (this.options[j].value === provinceCode && this.options[j].children.length) {
            for (let k = 0; k < this.options[j].children.length; k++) {
              if (this.options[j].children[k].value === cityCode && !this.options[j].children[k].children.length) {
                let ret = await areaList({ cityCode })
                if (ret.data.code === 0) {
                  if (!ret.data.data.result.length) { // 修复中山市/东莞市等三级为空数组的情况
                    let newArea = [{
                      value: this.options[j].children[k].value,
                      label: this.options[j].children[k].label
                    }]
                    this.$set(this.options[j].children[k], 'children', newArea)
                    break
                  }
                  let newData = JSON.stringify(ret.data.data.result)
                  newData = newData.replace(/areaCode/g, 'value')
                  newData = newData.replace(/areaName/g, 'label')
                  let newArea = JSON.parse(newData)
                  this.$set(this.options[j].children[k], 'children', newArea)
                  break
                }
              }
            }
          }
        }
      }
    },
    getAddressText (value) { // 获取地址
      for (var i = 0; i < this.options.length; i++) {
        if (this.options[i].value === value[0]) {
          this.address = this.options[i].label
          let city = this.options[i].children
          for (var j = 0; j < city.length; j++) {
            if (city[j].value === value[1]) {
              this.address += ',' + city[j].label
              let area = city[j].children
              for (var k = 0; k < area.length; k++) {
                if (area[k].value === value[2]) {
                  this.address += ',' + area[k].label
                }
              }
            }
          }
        }
      }
    },
    handleChangeFrom (value) {
      this.getAddressText(value)
      this.from = this.address
      // console.log(this.from + 'dsafsd')
    },
    handleChangeTo (value) {
      this.getAddressText(value)
      this.to = this.address
      // console.log(this.to)
    },
    onSubmit () { // search查询
      heightSource({
        startTime: this.startDate,
        endTime: this.endDate,
        departLand: this.from,
        destina: this.to,
        material: this.formInline.material

      }).then(res => {
        if (res.data.code === 0) {
          this.seniorGoodsInfo = res.data.data.result
        }
      })
    },
    handleClick (tab, event) { // table
      let goodsState = this.activeName === '0' ? '' : this.activeName - 1
      this.formInline = {
        material: ''
      }
      this.addressFrom = []
      this.addressTo = []
      this.startDate = ''
      this.endDate = ''

      heightSource({
        goodsState
      }).then(res => {
        if (res.data.code === 0) {
          this.seniorGoodsInfo = res.data.data.result
        }
      })
    },
    toggleSelection (rows) { // 权限用户反选
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    savePermission (id) { // 保存权限用户
      heightSave({
        seniorGoodsId: this.seniorGoodsId,
        userIds: id
      }).then(res => {
        if (res.data.code === 0) {
          this.getUserPermission(this.seniorGoodsId)
        }
      })
    },
    handleAddClick (id) { // 添加单个权限用户
      this.savePermission(id)
    },
    handleAddsClick () { // 批量添加权限用户
      let iditem = ''
      this.multipleSelection.forEach(res => {
        iditem += res.userId + ','
      })
      this.savePermission(iditem)
    },
    cancelPermission (id) { // 取消权限用户
      heightDelete({
        seniorGoodsId: this.seniorGoodsId,
        userIds: id
      }).then(res => {
        if (res.data.code === 0) {
          this.getUserPermission(this.seniorGoodsId)
        }
      })
    },
    handleCancelClick (id) { // 取消单个权限用户
      this.cancelPermission(id)
    },
    handleCancelLot () { // 批量取消权限用户
      let iditem = ''
      this.multipleSelection.forEach(res => {
        iditem += res.userId + ','
      })
      this.cancelPermission(iditem)
    },
    userPermissionClick (id) { // 权限用户
      this.seniorGoodsId = id
      this.inputName = ''
      this.getUserPermission(this.seniorGoodsId)
      this.userPermissionTable = true

      // this.timeOut = setTimeout(() => {
      // }, 200)
    },
    getUserPermission (id) { // 获取权限用户列表
      userPermission({ seniorGoodsId: id }).then(res => {
        if (res.data.code === 0) {
          this.userPermissionData = res.data.data.result
          // console.log(this.userPermissionData)
        }
      })
    },
    handleCarinfoClick (id) { // 匹配车辆
      // console.log(id)
      this.$router.push({ path: 'matchingInfo', query: { item: id } })
    },
    handleDetailClick (id) { // 匹配详情
      this.seniorGoodsId = id
      heightDriverOrder({ seniorGoodsId: id }).then(res => {
        if (res.data.code === 0) {
          this.showDetails = true
          this.detailList = res.data.data.vhbDriverOrders
        }
      })
    },
    handleCurrentChange (val) { // 切页切换
      let pageNum = val
      let status = this.activeName === '0' ? '' : this.activeName - 1

      heightSource({
        pageNum: pageNum,
        goodsState: status,
        startTime: this.startDate,
        endTime: this.endDate,
        departLand: this.from,
        destina: this.to,
        material: this.formInline.materia

      }).then(res => {
        this.seniorGoodsInfo = res.data.data.result
      })
    },
    querySearch (queryString, cb) { // 模糊查询
      var csvS = this.csvS
      cb(csvS)
    },
    createFilter (queryString) { // 模糊查询
      return (companyList) => {
        return (companyList.companyName.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
    handleSearchClick () { // 权限用户模糊查询功能
      let itemId = ''
      this.companyList.forEach(res => {
        if (res.companyName === this.inputName) {
          itemId = res.companyId
        }
      })
      userPermission({
        seniorGoodsId: this.seniorGoodsId,
        companyId: itemId
      }).then(res => {
        if (res.data.code === 0) {
          this.userPermissionData = res.data.data.result
        }
      })
    }
  },
  watch: {
    inputName: function () { // 模糊查询
      this.csvS = []
      var len = this.companyList.length
      var arr = []
      for (var i = 0; i < len; i++) {
        if (this.companyList[i].companyName.indexOf(this.inputName) >= 0) {
          arr.push(this.companyList[i])
        }
      }
      // el-autocomplete元素要求数组内是对象，且有value属性
      for (var j = 0; j < arr.length; j++) {
        var obj = { value: '' }
        obj.value = arr[j].companyName
        this.csvS.push(obj)
      }
    }
  },
  created () {
    // if (this.timeOut) {
    //   clearTimeout(this.timeOut)
    // }
    heightSource().then(res => {
      if (res.data.code === 0) {
        this.seniorGoodsInfo = res.data.data.result
        // console.log('seniorGoodsInfo', this.seniorGoodsInfo)
      }
    })
    allCompanyList({ // 初始化获取所有公司列表
      type: 1
    }).then(res => {
      if (res.data.code === 0) {
        this.companyList = res.data.data.result
        // console.log('compamny', this.companyList)
      }
    })
  },
  mounted () {
    this.initData()
  }
}
</script>
<style lang="stylus">
@import '~styles/varibles.styl'
@import '~styles/mixins.styl'
.senior
  height 100%
  background #f7f9fb
  .tabs
    height 51px
    overflow hidden
    .el-tabs__nav-wrap::after
      height 1px
      bottom 1px
    .el-tabs__item
      padding 0
      text-align center
      height 51px
      line-height 50px
      width 92px
      size12()
      color #5e656f
      &:hover
        color #1b88ee
    .el-tabs__item.is-active
      border-bottom 2px solid #409EFF
      color #1b88ee
    .el-tabs__active-bar
      background transparent !important
  .senior-search
    margin-top 4px
    padding 0 20px
    .el-table__header-wrapper, .el-form-item
      width 220px
      margin-bottom 10px
      margin-right 24px
      &:nth-last-child(1)
        margin-right 0
    .itembtn
      float right
      margin-right 0
      width auto
    .search-form-inline
      width 100%
      .company-name
        width 146px
        padding 0
        margin 0
      .el-input__inner
        width 146px
        height 28px
        size12()
      .imp
        display inline-block
        width 60px
        color #606266
        text-align right
      .addressStyle
        width 150px
        margin 0 20px 0 10px
        line-height 30px
      .search-submit
        padding 5px 20px
        background #fff
        text-align right
        color $bgColor
        size12()
        &:hover
          background $bgColor
          color #fff
    .el-date-editor.el-input, .el-date-editor.el-input__inner
      width 146px
      size12()
    .el-form--inline .el-form-item__label
      width 70px
      size12()
  .senior-container
    margin-left 20px
    margin-right 20px
    height calc(100% - 200px)
    overflow hidden
    .table_main
      overflow-y hidden
      background #f7f9fb
    .el-table th
      background #e7f0f8
    .el-table td div
      size12()
    .el-table th>.cell
      size12()
    .status-style
      width 40px
      height 40px
      border-radius 50%
      margin 0 auto
      border 1px solid transparent
      size10()
      line-height 40px
      text-align center
    .wating
      wating()
    .progress
      progress()
    .complated
      complated()
    .failure
      failure()
      size10()
    .el-button
      size12()
      margin-bottom 10px
      margin-left 10px
    .btna
      btna()
    .btnb
      btnb()
    .btnc
      btnc()
    .userPermissionTable, .biddingTable
      .el-dialog
        width auto
        width 728px
        .el-dialog__header
          height 42px
          padding 0 20px 0
          background #1b88ee
          .el-dialog__title
            line-height 42px
            font-size 13px
            color #fff
            float left
          .el-dialog__headerbtn
            top 12px
            right 12px
            .el-dialog__close
              color #fff
              font-size 20px
        .el-dialog__body
          padding 15px 20px
          .companySelect
            width 180px
            height 30px
            margin 0
            float left
            margin-bottom 20px
            .el-input__inner
              width 145px
              height 30px
            .el-input-group__append
              padding 0
              .el-button
                margin 0
              .el-button--mini, .el-button--mini.is-round
                padding 7px 12px
          .operation
            .el-button
              margin 0
              padding 7px 27px
          .operations
            .el-button
              margin-bottom 0
              padding 7px 27px
          .permission_search
            float left
            margin-bottom 20px
    .biddingTable
      color #5E656F
      .stylus_car
        color #1B88EE
      .completed
        color #00D5B9
      .canceled
        color #5E656F
      span
        color #858C96
  .pages
    pages()
  .el-table td, .el-table th
    vertical-align top
</style>
